import "./What_Customer_Say.css";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import ReactStars from "react-rating-stars-component";
import { Customers } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";
import SectionTitle from "../../common/common_title/SectionTitle";
const What_Customer_Say = () => {
  const ratingChanged = (newRating) => {
    console.log(newRating);
  };
  const testimonialData = [
    {
      id: 1,
      name: "Milind Patil",
      image: "/assets/images/aboutus/why choose/screw.png",
      review:
        "Hindustan Solar is one of the best solar system installation company. We installed solar system at our house through them. And while doing this work, the company's colleagues gave us very good service. The system and other information required in that context are kept very transparent. Thanks to Mr. Manoj Shivankar of Hindustan Solar for guiding us properly for our home solar system installation.",
    },
    {
      id: 2,
      name: "Rohit Sharma",
      image: "/assets/images/aboutus/why choose/professional.png",
      review:
        "Solar panel fitting requires careful planning regarding system capacity roof structure integrity, and choosing certified installers to ensure guaranteed saving and safety. Key feedback induced insuring proper south facing tilt for maximum generation , implementing net metering , and verifying warranties. Expect significant but not always 100% energy offsets depending on weather. Thank you",
    },
    {
      id: 3,
      name: "Ananya Verma",
      image: "/assets/images/aboutus/why choose/component.png",
      review:
        "Hindustan Solar did everything they said they would do, within the timeline they proposed. There were no surprises or “add-ons” to deal with, which I greatly appreciated. Responses to my questions/concerns was always complete, timely, and professional. Mr. Sifan was there to assist from the original proposal to the completion of the final paperwork. He also kept me updated on the status of whole program, and got me all the paperwork quickly to ensure I didn”t miss out on that opportunity. The quality product, professionalism of the whole team, and reputation of Hindustan Solar made this a seamless and stress-free endeavor.",
    },
    {
      id: 4,
      name: "Rohit Sharma",
      image: "/assets/images/aboutus/why choose/mechanic.png",
      review:
        "Excellent service … Right form the Enquiry till completion of the plant. Share electricity bill of your home or office and they will do the rest. You just need to relax and wait till the procedure is completed.Team is very well trained and of course well behaved. Good team efforts.Hindustan Team all the very best … !!!",
    },
    {
      id: 5,
      name: "Ananya Verma",
      image: "/assets/images/aboutus/why choose/save-money.png",
      review:
        "I’m very impressed with their service.The team was professional and completed the installation on time.The system is working efficiently and my electricity bill has reduced significantly.I highly recommend Hindustan Solar for solar solutions.",
    },
  ];

  const { IMG_URL } = useContext(Context);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [customer, setCustomer] = useState([]);

  const getCustomers = async () => {
    const res = await Customers();
    if (res?.success) {
      setCustomer(res?.data?.data);
    }
  };
  useEffect(() => {
    getCustomers();
  }, []);

  const [swiperInstance, setSwiperInstance] = useState(null);
  const handleMainSliderClick = (direction) => {
    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  return (
    <section className="What_Customer_Say">
      <div className="container">
        <div className="What_Customer_Say_div">
          <div className="heading-wrapper">
            {" "}
            <SectionTitle
              title="Testimonials"
              subtitle="What Our Clients Say"
              className="h-title"
            />
          </div>

          {/* Swiper */}
          <div className="testimonial_swiper_wrapper">
            <Swiper
              onSwiper={setSwiperInstance}
              modules={[Pagination]}
              slidesPerView={"auto"}
              spaceBetween={15}
              loop={true}
              centeredSlides={false}
              speed={600}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: { slidesPerView: 1.5, centeredSlides: true },
                576: { slidesPerView: 2, centeredSlides: true },
                768: { slidesPerView: 2.5, centeredSlides: true },
                1000: { slidesPerView: 3, centeredSlides: false },
                1199: { slidesPerView: 4, centeredSlides: false },
              }}
              className="testimonial_swiper"
            >
              {/*--------------- old code ----------- */}
              {/* {customer.map((item) => (
                <SwiperSlide key={item.id}>
                  <div className="testimonial_card">
                    <div className="row align-items-center justify-content-center">
                      <div className={`col-lg-5 col-md-6 col-sm-6 col-12 `}>
                        <div className="testimonial_image">
                          <img
                            src={IDS?.IMG_URL + item?.image}
                            alt={item.name}
                            className="card_img"
                          />
                        </div>
                      </div>

                      <div className="col-lg-7 col-md-12">
                        <div className="testimonial_content">
                          <div className="quote_holder">
                            <img
                              src="/assets/images/home/what_customer_say/right-quote.png"
                              alt="quote"
                              className="quote_img"
                            />
                          </div>

                          <div className="profile_name_holder">
                            <img
                              src={IDS?.IMG_URL + item?.logo}
                              alt="profile"
                              className="profile_img"
                            />
                            <h6 className="testimonial_name">{item.name}</h6>
                          </div>
                          <p className="testimonial_review">
                            {htmlToReactParser.parse(item.description)}
                          </p>

                          <div className="rating-history-stars-container">
                            <div className="rating-history-stars-box">
                              <ReactStars
                                count={5}
                                value={item?.rating || 0}
                                edit={false}
                                size={30}
                                activeColor="#ffd700"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))} */}
              {customer?.map((item, index) => (
                <SwiperSlide key={item.id}>
                  <div className="testimonial_card_small">
                    <div className="profile_row">
                      <div className="img-wrapper">
                        <img
                          src={IDS?.IMG_URL + item?.image}
                          alt=""
                          className="profile_img"
                        />
                      </div>
                      <div>
                        <h6 className="name">{item?.name}</h6>
                        <p className="role">{item?.position}</p>{" "}
                      </div>
                    </div>

                    <p className="review">
                      {htmlToReactParser.parse(item?.description)}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default What_Customer_Say;
